var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allProductsBox"},[(_vm.calssLists)?_c('ul',{staticClass:"lists"},_vm._l((_vm.calssLists),function(item,index){return _c('li',{key:index,staticClass:"item",on:{"click":function($event){return _vm.getProductDetails(item)}}},[_c('van-image',{staticClass:"productImg",attrs:{"src":item.ClassImg}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }